<template>
    <div class="custom-marker">
        <div class="content-area">
            <span class="text-primary cursive mb-0 nowrap" style="cursor: pointer!important">{{value.substring(0, 50)}}</span>
        </div>
        <div class="square">
        </div>
    </div>
</template>

<script>
export default {
  name: 'CustomGenericMarker',
  props: {
    value: String
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/google-map/CustomGenericMarker.vue